import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import AsyncComponent from '../AsyncComponent';

import GuestRoute from '../GuestRoute';

const Login = AsyncComponent(() => import('../../screens/Login'));
const ForgotPassword = AsyncComponent(() =>
	import('../../screens/ForgotPassword')
);
const Verify = AsyncComponent(() => import('../../screens/Verify'));

const IframePlayer = AsyncComponent(() => import('../../screens/IframePlayer'));
const Survey = AsyncComponent(() => import('../../screens/Survey'));

const ViewerZoneContainer = AsyncComponent(() =>
	import('../../screens/ViewerZone/ViewerZoneContainer')
);
const Encoder = AsyncComponent(() => import('../../screens/Encoder'));

const RouterComponent = ({
	process,
	currentUser,
	authenticated,
	onRequestLoading,
	onLogout,
	firebase,
}) => {
	return (
		<Router basename={process.env.PUBLIC_URL}>
			<div className="az-body">
				<Switch>
					<GuestRoute
						exact
						path="/forgot-password"
						component={ForgotPassword}
					/>
					<GuestRoute
						exact
						path="/verify"
						component={Verify}
						onLogout={onLogout}
						onRequestLoading={onRequestLoading}
					/>
					<GuestRoute
						exact
						path="/login/547a880eaf2d276769cacf3a6e721c6a"
						component={Login}
						authenticated={authenticated}
						closeOnLogin={true}
					/>
					<GuestRoute
						exact
						path="/iframe/:organizer/:event_name"
						authenticated={authenticated}
						currentUser={currentUser}
						onLogout={onLogout}
						component={IframePlayer}
						noRedirect
					/>

					<GuestRoute
						exact
						path="/feedback/:id"
						authenticated={authenticated}
						currentUser={currentUser}
						onLogout={onLogout}
						noRedirect
						component={Survey}
					/>

					<GuestRoute
						exact
						path="/encoder/:organizer/:id"
						authenticated={authenticated}
						currentUser={currentUser}
						onLogout={onLogout}
						noRedirect
						component={Encoder}
						firebase={firebase}
					/>

					<GuestRoute
						exact
						path="/:organizer/:event_name"
						authenticated={authenticated}
						currentUser={currentUser}
						onLogout={onLogout}
						component={ViewerZoneContainer}
						noRedirect
					/>
					<GuestRoute component={Login} authenticated={authenticated} />
				</Switch>
			</div>
		</Router>
	);
};

export default RouterComponent;
